export const isNonMigratedFacility = (facilityId: string) => facilityId === '-1';
